export default "__VITE_ASSET__CLZSYtMD__"